import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=17bbb15f&scoped=true&"
import script from "./Manager.vue?vue&type=script&lang=ts&"
export * from "./Manager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bbb15f",
  null
  
)

export default component.exports